import getScrollbarWidth from '../../functions/get-scrollbar-width'
import MicroModal from 'micromodal'

MicroModal.init({
  awaitCloseAnimation: true,
  onShow () {
    document.documentElement.style.overflowY = 'hidden'
    document.documentElement.style.paddingRight = getScrollbarWidth() + 'px'
  },
  onClose () {
    document.documentElement.style.overflowY = ''
    document.documentElement.style.paddingRight = ''
  }
})



// WEBPACK FOOTER //
// ./src/components/modal/scripts.js